import React from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { color, ColorProps } from "styled-system";
import { Typography, Card, Box, LinkButton } from "@bca/ui-library";

import VehicleTypes from "../types/vehicleTypes";
import { Report } from "../vehicleDetails/vehicle-details-props.type";

import getGradesDetails from "../utilities/getGradesDetails";

interface GradeProps extends ColorProps {
  children: React.ReactNode;
}

const Grade = styled.div<GradeProps>`
  ${css({
    mr: 2,
    fontSize: 4,
  })}
  ${color}
`;

const GradeIcon = styled.div<GradeProps>`
  display: flex;
  width: 29px;
  height: 29px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  font-size: 19px;
  ${css({
    color: "primary-white",
  })}
  ${color}
`;

interface ConditionReportDetailsProps {
  report: Report;
  grade: number;
  vehicleType: VehicleTypes;
}

const StyledTypography = styled(Typography)`
  white-space: pre-line;
`;

const ConditionReportDetails: React.FunctionComponent<
  ConditionReportDetailsProps
> = ({ report: { href }, grade, vehicleType }) => {
  const gradesDetails = getGradesDetails(vehicleType);

  const titleCss = "margin: 0";
  const cardCss = `
    display: flex;
    flex-direction: column;
    `;
  const linkCss = `
    justify-content: flex-start;
    height: auto;
    `;

  return (
    <Card
      width={["100%", "49%"]}
      height="auto"
      marginX={0}
      marginY={0}
      css={cardCss}
      data-testid="condition-report-card"
    >
      <Box display="flex" justifyContent="space-between">
        <Typography variant="h5" css={titleCss}>
          Condition Report
        </Typography>
        <Box display="flex">
          <Grade color={gradesDetails[grade].color}>
            {gradesDetails[grade].label}
          </Grade>
          <GradeIcon data-testid="grade-icon" bg={gradesDetails[grade].color}>
            {gradesDetails[grade].icon}
          </GradeIcon>
        </Box>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        flex={1}
        justifyContent="space-between"
      >
        <StyledTypography variant="body" color="grey-blue">
          {gradesDetails[grade].text}
        </StyledTypography>
        <LinkButton
          link={href}
          text={"View Condition Report"}
          shouldOpenInNewWindow
          icon="arrow-right-solid"
          iconAlignment="right"
          variant="tertiary"
          paddingX={0}
          css={linkCss}
          data-en="click"
          data-ec="button"
          data-el="condition-report"
          data-ea="download"
          data-es="secondary-information"
        ></LinkButton>
      </Box>
    </Card>
  );
};

export default ConditionReportDetails;
